// MUI components
import { ColumnData } from "assets/types/ColumnData";

const columns: ColumnData[] = [
	{
		headerName: "User Id",
		field: "userId",
		renderCell: ({ row }) => <>{row.id}</>,
	},
	{
		headerName: "User Name",
		field: "userName",
		renderCell: ({ row }) => <>{row.name}</>,
	},
	{ headerName: "Email", field: "email" },
	{
		headerName: "Phone No.",
		field: "phoneNo",
		renderCell: ({ row }) => <>{row.phone}</>,
	},
	{
		headerName: "Order Count",
		field: "orderCount",
		renderCell: ({ row }) => <>{row.numOfOrders || 0}</>,
	},
	{
		headerName: "Total Spend",
		field: "totalSpend",
		renderCell: ({ row }) => <>{row.totalAmount || 0}</>,
	},
];

const dataTableData = {
	columns,
};

export default dataTableData;
